<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'HomepageMobile' && document.body.offsetWidth > 500) {
        this.$router.replace('/')
      }
      if (to.name === 'HomePage' && document.body.offsetWidth < 500) {
        window.location.href = '/homepage_m'
      }
      if (from.name === 'Login') {
        clearInterval(window.timer)
      }
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue